module.exports = __webpack_public_path__ + "media/dashboard/assets/images/video-off-bc3e1a063ad22ce5cd5aa49a9d58fa81.svg";